export default "/images/25c4964adc265f8d16b53841651f6d43.avif";